import { Accordion, Callout, PageModal, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { Link as LinkIcon } from '@otp/icons';

export interface UsageRelation {
  name: string;
  icon: any;
  items: Array<{
    id: string;
    name: string;
    link: string;
  }>;
}

interface DeletingUsedItemModalProps {
  title: string;
  description: string;
  relations: Array<UsageRelation>;
  onClose?: () => void;
}

export const DeletingUsedItemModal = ({
  title,
  description,
  relations,
  onClose,
}: DeletingUsedItemModalProps) => {
  const { t } = useTranslation();

  return (
    <PageModal open onClose={() => onClose?.()} title={title}>
      {description && <Typography fontSize={14}>{description}</Typography>}

      {relations.map((relation, index) => (
        <Accordion
          variant="contained"
          noBorder
          key={relation.name}
          title={relation.name}
          defaultExpanded={index === 0}
        >
          {relation.items.map((item) => (
            <Callout
              key={item.id || item.name}
              icon={false}
              className="mb-2 py-0"
              severity="warning"
            >
              <div className="flex justify-between">
                <span>{item.name}</span>
                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center py-1 px-2 rounded-md bg-white text-xs border-gray-200 border border-solid"
                >
                  <LinkIcon className="scale-90" />
                  <span className="ml-1.5">{t('common.go-to')}</span>
                </a>
              </div>
            </Callout>
          ))}
        </Accordion>
      ))}
    </PageModal>
  );
};
